(function () {
    'use strict';
    angular
            .module('imnApp')
            .factory('LoginService', LoginService);

    LoginService.$inject = ['$http', '$state', 'RequestService', 'ModalConstructor', 'AlertModalService', 'UserData'];

    function LoginService($http, $state, RequestService, ModalConstructor, AlertModalService, UserData) {

        return {
            // Login Methods
            login: login,
            logout: logout,
            // Modal Methods
            recoverLoginModalConstructor: recoverLoginModalConstructor,
            alertNotificationModalConstructor: alertNotificationModalConstructor,
            supportLoginModalConstructor: supportLoginModalConstructor,
            errorModalConstructor: errorModalConstructor,
            successModalConstructor: successModalConstructor
        };

        // Login Methods
        function login(credentials) {
            return $http.post(apiUrl('login'), credentials, configLogin()).then(responseData);
        }

        function logout() {
            return $http
                    .post(apiUrl('logout'))
                    .then(function () {
                        ModalConstructor.closeAll();
                        UserData.reset();
                        $state.go('login');
                    });
        }

        // Modal Methods
        function recoverLoginModalConstructor() {
            var recover = {
                templateUrl: 'app/components/login/login-recover-password.html',
                controller: 'RecoverController',
                controllerAs: 'vmRecover',
                size: 'sm',
                backdrop: 'static'
            };
            ModalConstructor.open(recover);
        }

        function alertNotificationModalConstructor(action) {
            var warning = {
                templateUrl: 'app/components/login/login-alert-notification.html',
                controller: alertNotificationController,
                controllerAs: 'vmAlertNotification',
                size: 'sm',
                windowClass: 'modal-alert modal-warning',
                avoidCancel: true,
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                            $translatePartialLoader.addPart('login');
                            return $translate.refresh();
                        }]
                }
            };

            alertNotificationController.$inject = ['$uibModalInstance'];
            function alertNotificationController($uibModalInstance) {
                this.modalMessage = 'loginWarning.' + action + '.message';
                this.close = function () {
                    $uibModalInstance.dismiss('cancel');
                }
            }

            return ModalConstructor.open(warning);
        }

        function supportLoginModalConstructor() {
            var support = {
                templateUrl: 'app/components/login/login-support.html',
                controller: 'SupportController',
                controllerAs: 'vmSupportController',
                size: 'sm',
                backdrop: 'static'
            };
            ModalConstructor.open(support);
        }

        function errorModalConstructor(response, action) {
            if (response.status == 401 && response.data.message == 'Authentication Failed: Maximum number of accesses reached') {
                response.status = '401.1';
            }
            AlertModalService.error(response, action, 'login');
        }

        function successModalConstructor(action, isMultiple) {
            AlertModalService.success(action, isMultiple, 'login');
        }

        // Helper functions
        function apiUrl(method) {
            return RequestService.baseUrl(method);
        }

        // Return only the data of the response
        function responseData(response) {
            return response.data;
        }

        function configLogin() {
            return {
                headers: {'Content-Type': 'application/x-www-form-urlencoded'},
                transformRequest: function (obj) {
                    var str = [];
                    for (var p in obj) {
                        str.push(encodeURIComponent(p) + '=' + encodeURIComponent(obj[p]));
                    }
                    return str.join('&');
                }
            };
        }

    }
})();